import { EditorSelection } from "@codemirror/state";

export const selectNode = (view, extents) => {
    const from = Math.max(0, extents.from);
    const to = Math.max(from, extents.to);

    view.dispatch({
        selection: EditorSelection.single(from, to),
        scrollIntoView: true,
    });
};
